import React, {useState} from 'react';
import {TextField} from '@mui/material';
import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {toast} from 'react-toastify';

import ButtonDialog from 'components/forms/ButtonDialog';
import {Button} from 'components/forms/Buttons';
import {useRecordContext} from 'components/record/useRecordContext';
import {useListContext} from 'components/list/ListContext';
import {useDialogContext} from 'components/dialog/DialogContext';

const IMPORT_FROM_LIVELOX = gql`
  mutation ImportSubEventFromLiveloxUrl($slug: String!, $url: String!) {
    importSubEventFromLiveloxUrl(slug: $slug, url: $url) {
      id
      name
      sub
    }
  }
`;

const FORM_ID = 'import_from_livelox';

const ImportFromLiveloxBody = () => {
  const {record: event} = useRecordContext();
  const {refetch} = useListContext();
  const {close} = useDialogContext();
  const [url, setUrl] = useState('');

  const [importFromLivelox, {loading}] = useMutation<{importSubEventFromLiveloxUrl: {id: number}}>(IMPORT_FROM_LIVELOX);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmed = url.trim();
    if (!trimmed) {
      toast.error('Please enter a Livelox URL');
      return;
    }
    try {
      const result = await importFromLivelox({variables: {slug: event.slug, url: trimmed}});
      if (result.data?.importSubEventFromLiveloxUrl) {
        toast.success('Sub-event imported from Livelox successfully');
        if (typeof refetch === 'function') refetch();
        close();
      }
    } catch (e) {
      if (e instanceof Error && e.message) toast.error(e.message);
    }
  };

  return (
    <form id={FORM_ID} onSubmit={handleSubmit} noValidate>
      <TextField
        autoFocus
        fullWidth
        required
        disabled={loading}
        label="Livelox class storage URL"
        placeholder="https://livelox.blob.core.windows.net/class-storage/..."
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        size="small"
        margin="normal"
        helperText="Paste the URL of the Livelox class export JSON. Existing imports for the same URL will be skipped."
      />
    </form>
  );
};

const ImportFromLiveloxButton = () => {
  return (
    <ButtonDialog
      buttonLabel="LiveLox"
      variant="text"
      dialogTitle="Import from Livelox"
      maxWidth="sm"
      primaryButton={
        <Button type="submit" form={FORM_ID}>
          Import
        </Button>
      }
    >
      <ImportFromLiveloxBody />
    </ButtonDialog>
  );
};

export default ImportFromLiveloxButton;
